import React, {useEffect, useState} from 'react';
import {ThemeProvider} from "styled-components";
import ThemeUtilities from "./utilities/ThemeUtilities";
import SiteRouter from "./routing/SiteRouter";
import _device_service from "./services/DeviceService";

interface SiteProps {
}

function Site(props: SiteProps) {

    const {theme, themeLoaded} = ThemeUtilities.useTheme(_device_service.getBrowserUrl());
    const [selectedTheme, setSelectedTheme] = useState(theme);

    useEffect(() => {
        setSelectedTheme(theme);
    }, [theme]);

    return (
        <>
            {themeLoaded &&
                <ThemeProvider theme={selectedTheme}>
                    <ThemeUtilities.GlobalStyles/>
                    <SiteRouter/>
                </ThemeProvider>
            }
        </>
    );
}

export default Site;